import { api } from './client'

/** Stato della chiave IA per la lettura documenti: la chiave non torna mai al browser. */
export interface AiSettings {
  configured: boolean
  model: string
  encryptionAvailable: boolean
  updatedAt: string | null
}

export const aiSettingsApi = {
  get: () => api<AiSettings>('/api/settings/ai'),
  save: (apiKey: string) => api<void>('/api/settings/ai', { method: 'PUT', body: JSON.stringify({ apiKey }) }),
  remove: () => api<void>('/api/settings/ai', { method: 'DELETE' }),
}
